import {DlMuiButton, GetStylesFunction} from '@wallaby-ui/core';
import React, {FC} from 'react';
import {css, useTheme} from '@mui/material';

interface Props {
  onDatePickerClear: () => void;
  disabled?: boolean;
}

export const FilterNodeRangeCancelButton: FC<Props> = (props: Props) => {
  const {onDatePickerClear, disabled} = props;

  const theme = useTheme();
  const muiStyles = getStyles({theme});

  return (
    <DlMuiButton
      type='chip-filled'
      data-name={'dl-mui-date-picker-action-bar--clear'}
      css={muiStyles.button}
      title={'filter.remove'}
      onClick={onDatePickerClear}
      disabled={disabled}
    />
  );
};

const getStyles: GetStylesFunction = () => ({
  button: css`
    background-color: white !important;
    color: var(--dlTheme-500) !important;
    border: 1px solid var(--dlTheme-500) !important;

    &:active,
    &:hover {
      background-color: white !important;
      color: var(--dlTheme-600) !important;
      border: 1px solid var(--dlTheme-600) !important;
    }
  `,
});
